import Dialog from '../lib/dialog';
import MapMenu from '../lib/map_menu';

export default class HelpView {
	/**
	 * Main view content is in DOM, hidden
	 */
	content() {
		return document.getElementById('map-help').innerHTML;
	}

	load() {
		Dialog.loadContent(this.content()).then((dialog) => {
			dialog.setAttribute('aria-labelledby', 'dialog-label');
			dialog.classList.add('dialog-help');
			dialog.classList.add('fixed-height');
		});
	}

	static addListeners() {
		const helpLink = document.getElementById('help-link');
		if (!helpLink) return;
		helpLink.addEventListener('click', () => {
			const help_view = new HelpView();
			help_view.load();
			MapMenu.hide();
		});
	}
}

HelpView.addListeners();
